export default "__VITE_ASSET__VDbNqK1u__"